import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

const ADMIN_QUOTES_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/quotes`;

export const QUOTES_API_PATHS = {
  LIST: ADMIN_QUOTES_API_ROOT,
  CREATE: ADMIN_QUOTES_API_ROOT,
  BY_ID: (id: string) => `${ADMIN_QUOTES_API_ROOT}/${id}`,
  UPDATE: (id: string) => `${ADMIN_QUOTES_API_ROOT}/${id}`,
  READY: (id: string) => `${ADMIN_QUOTES_API_ROOT}/${id}/ready`,
  SEND: (id: string) => `${ADMIN_QUOTES_API_ROOT}/${id}/send`,
  ACCEPT: (id: string) => `${ADMIN_QUOTES_API_ROOT}/${id}/accept`,
  REFUSE: (id: string) => `${ADMIN_QUOTES_API_ROOT}/${id}/refuse`,
  CANCEL: (id: string) => `${ADMIN_QUOTES_API_ROOT}/${id}/cancel`,
  DUPLICATE: (id: string) => `${ADMIN_QUOTES_API_ROOT}/${id}/duplicate`,
  DOWNLOAD_URL: (id: string) => `${ADMIN_QUOTES_API_ROOT}/${id}/download-url`,
};
